<template lang="pug">
  div
    .row
      p.col.s12.title.medium Remove Supplier Shop
      p.col.s12 Remove 
        strong {{shop.name}}
        | ? This can't be undone.
    .row.right-align
      a.btn.btn-flat(@click='cancel') Cancel
      a.btn(@click='confirm') Confirm
</template>
<script>
export default {
  props: ['supplierId', 'shop', 'onRemoveSuccess', 'onRemoveError', 'onRemoveCancelled'],
  methods: {
    cancel () {
      this.onRemoveCancelled()
    },
    confirm () {
      this.$store.dispatch('auth/getAccessToken').then(accessToken => {
        return this.$http.delete(`${this.$config.API_URL}/admin/suppliers/${this.supplierId}/shops`, {
          params: {
            shopId: this.shop.id
          },
          headers: {
            authorization: `Bearer ${accessToken}`
          }
        }).then(() => {
          this.onRemoveSuccess()
        })
      }).catch(err => {
        this.onRemoveError(err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal-remove-supplier-shop.vue